import { Component, OnInit, Input } from '@angular/core';
import { PropertyListItem } from './../../property';
import { PersonService } from './../../../person';

@Component({
  selector: 'app-addon-auction',
  templateUrl: './addon-auction.component.html',
  styleUrls: ['../templates.scss', './addon-auction.component.scss']
})
export class AddonAuctionComponent implements OnInit {
  @Input() property: PropertyListItem;
  @Input() routes: any = {};
  assetManager: string;

  constructor(private personService: PersonService) { }

  ngOnInit() {
    this.property.Roles.filter((i) => {
      this.assetManager = (i.Role.Key === 'asset_man') ? this.personService.getFullName(i.Person) : this.assetManager;
    });
  }

}
